import React from 'react';
import { MapPinIcon } from 'lucide-react';
import { Store, MediaType, SlotStatus } from '../../data/types';
import { getStoreAvailabilitySummary } from '../../data/stores';
import { Badge } from '../ui/Badge';
import { AvailabilityDot } from './AvailabilityDot';
interface StoreRowProps {
  store: Store;
  onClick: () => void;
  isEven: boolean;
  visibleMediaTypes?: MediaType[];
  availabilityFilter?: SlotStatus | 'all';
  selectable?: boolean;
  isSelected?: boolean;
  onToggleSelect?: (storeId: string) => void;
}
const defaultMediaTypes: MediaType[] = ['Digital Outposts', 'Digital Drive Aisle', 'Digital Windows'];
export function StoreRow({
  store,
  onClick,
  isEven,
  visibleMediaTypes,
  availabilityFilter = 'all',
  selectable = false,
  isSelected = false,
  onToggleSelect
}: StoreRowProps) {
  const summaryAvailability = getStoreAvailabilitySummary(store);
  const mediaTypesToShow = visibleMediaTypes || defaultMediaTypes;
  const getStatusForMediaType = (mediaType: MediaType): SlotStatus | null => {
    if (availabilityFilter === 'all') {
      return summaryAvailability[mediaType];
    }
    // When a filter is active, only show media types that match the filter
    const hasMatch = store.slots.some(slot => slot.mediaType === mediaType && slot.status === availabilityFilter);
    return hasMatch ? availabilityFilter : null;
  };
  return <tr onClick={onClick} className={`
        cursor-pointer transition-colors duration-100
        ${isEven ? 'bg-white' : 'bg-surface'}
        ${isSelected ? 'bg-primary/5 hover:bg-primary/10' : 'hover:bg-surface-warm'}
      `} role="button" tabIndex={0} onKeyDown={e => e.key === 'Enter' && onClick()} aria-label={`View timeline for ${store.name}`} data-id="element-661">
      {selectable && <td className="px-4 py-4 w-12" onClick={e => {
      e.stopPropagation();
      onToggleSelect?.(store.id);
    }} data-id="element-662">
          <input type="checkbox" checked={isSelected} onChange={() => {}} // Handled by td onClick
      className="w-4 h-4 rounded-sm border-border text-primary focus:ring-primary cursor-pointer" aria-label={`Select ${store.name}`} data-id="element-663" />
        </td>}
      <td className="px-4 py-4" data-id="element-664">
        <div className="font-medium text-text-primary" data-id="element-665">{store.name}</div>
      </td>
      <td className="px-4 py-4" data-id="element-666">
        <div className="flex items-center gap-1.5 text-sm text-text-secondary" data-id="element-667">
          <MapPinIcon className="w-3.5 h-3.5" data-id="element-668" />
          {store.location}
        </div>
      </td>
      <td className="px-4 py-4 text-sm text-text-secondary" data-id="element-669">
        {store.province}
      </td>
      <td className="px-4 py-4" data-id="element-670">
        <Badge variant={store.tier} data-id="element-671">{store.tier.replace('-', ' ')}</Badge>
      </td>
      {mediaTypesToShow.map(mediaType => {
      const status = getStatusForMediaType(mediaType);
      return <td key={mediaType} className="px-4 py-4" data-id="element-672">
            {status ? <AvailabilityDot status={status} data-id="element-673" /> : <span className="text-xs text-text-tertiary opacity-40" data-id="element-674">—</span>}
          </td>;
    })}
    </tr>;
}